/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import {
    object, string, func, number, bool, array,
} from 'prop-types';

// Material UI
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { CircularProgress } from '@material-ui/core';

// Constants
import States from '../Partials/constants/states';
import { defaultCountryList } from '../Partials/constants/country';

// Checkout UI
import GoogleAddressSearch from '../../../../Checkout/containers/Common/GoogleAddressSearch/GoogleAddressSearch';
import AddressVerificationSearch from '../../../../Checkout/containers/Common/AddressVerificationSearch/AddressVerificationSearch';
import AddressBookWithPagination from '../../../../Checkout/containers/CheckoutFood/components/Partials/AddressBookWidget/AddressBookWithPagination';
import QasAddressVerificationModal from '../../../../Checkout/containers/CheckoutFood/components/Partials/QasAddressVerification/QasAddressVerificationModal/QasAddressVerificationModal';
import withValidation from '../../../../Checkout/containers/CheckoutFood/components/Partials/TextFieldWrapper/ValidationHOC';

// Checkout
import * as recipientFormActions from '../../../../../../state/ducks/Recipient/ducks/RecipientForm/RecipientForm-Actions';

// Member
import memberDucks from '../../../../../../state/ducks/Member/ducks';

import {
    getCountryField,
} from '../../../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Helper';
import { getHasQasFailed } from '../../../../../../state/ducks/Common/Common-Selectors';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { getBrand, getFlags, getMembershipType } from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { subscriptionVerifyAddress } from '../../../../../../state/ducks/App/App-Actions';
import { commonSelectors, commonDucks } from '../../../../../../state/ducks/Common';
import { getIsWriteScopeCheckout } from '../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';
import getLocationType from '../../../../../helpers/getLocationType';
import { isEmpty } from '../../../utils/object';
import getListLocationTypes, { getInputProperties, propertiesTypeByProduct } from './helpers';
import TextFieldWrapper from '../Partials/TextFieldWrapper/TextFieldWrapper';
import { productAvailability } from '../../SubscriptionsV2/helper';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

// Common Ducks
const { errorActions } = commonDucks.error;
const { qasAddressSearchActions } = commonDucks.qasAddressSearch;

const {
    common: {
        commonSelectors: {
            getAddressBookEntries,
            getUserType,
            getTotalNoOfPages,
            getAddressBookPageNumber,
            getTotalEntriesAddressBook,
        },
    },
    addressBook: {
        addressBookActions: {
            loadAddressBook: loadAddressBookAction,
        },
    },
} = memberDucks;

const styles = (theme) => ({
    cardHeaderWrap: {
        borderBottom: `1px solid ${theme.palette.grey5}`,
    },
    cardHeaderRoot: {
        padding: '12px',
    },
    cardHeaderTitle: {
        fontSize: '15px',
        fontWeight: '600',
    },
    divFullRow: {
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: '9px',
    },
    apoHelpLink: {
        color: '#00e',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    apoLink: {
        marginTop: '9px',
    },
    checkboxLabel: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '15px',
        fontWeight: '600',
        color: theme.palette.black,
        position: 'relative',
    },
    actionButtonRow: {
        marginTop: '10%',
    },
    apoInfoPaper: {
        position: 'absolute',
        width: '70%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '10px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    scrollStyle: {
        overflow: 'inherit',
    },
    stateField: {
        paddingTop: '7px',
    },
    countryField: {
        paddingTop: '8px',
    },
    citySelect: {
        paddingTop: '8px',
        marginBottom: '8px',
    },
    [theme.breakpoints.down('md')]: {
        formContainer: {
            '& label': {
                fontSize: '16px',
            },
            // Used contains Mui class name to avoid CSS issue on Account MFE
            '& [class*="MuiGrid-spacing-xs-2"] > div': {
                paddingTop: '0px',
                paddingBottom: '0px',
            },
        },
        marginBottomSpace: {
            marginBottom: '9px',
        },
        inputText: {
            '& label': {
                fontSize: '13px',
            },
        },
        dropDownView: {
            position: 'relative',
            '& label': {
                position: 'absolute',
            },
            // Used contains Mui class name to avoid CSS issue on Account MFE
            '& select, [class*="MuiSelect-select"]': {
                paddingTop: '22px',
            },
            '&$stateField': {
                paddingTop: '0px',
            },
            '&$countryField': {
                paddingTop: '0px',
            },
        },
        citySelect: {
            paddingTop: '0px',
            marginBottom: '0px',
        },
        checkboxLabel: {
            fontSize: '14px',
        },
    },
    secondaryButtonStyle: {
        backgroundColor: 'transparent',
        color: theme.palette.black,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.black}`,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
        '&:hover': {
            color: theme.palette.white,
        },
    },
    primaryButtonStyle: {
        color: theme.palette.white,
        backgroundColor: theme.palette.primaryButton,
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 16px',
        borderRadius: '30px',
        border: `1px solid ${theme.palette.primaryButton}`,
        boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
    },
});

const initState = {
    locationType: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    firstName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    lastName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    organizationName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    address1: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    address2: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    city: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    state: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    zipCode: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    country: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    phone: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    email: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
};

function removeUSZipCodeSegment(zipcode) {
    if (/\d{5}-\d{4}/.test(zipcode)) {
        const zipSplit = zipcode.split('-');
        return zipSplit[0];
    }
    return zipcode;
}

class SubscriptionRecipientForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notAvailableCity: false,
            notAvailableCityObj: {
                key: 'CNS',
                value: 'City Not Shown',
            },
            address2Display: 'block',
            checkSameAsDeliveryAddress: false,
            useAddressForAll: false,
            initRender: false,
            openModelApoInfo: false,
            addressSearch: {
                focus: false,
                valueOnKeyUp: '',
            },
            oldRecipientData: {},
            isProductAvailable: '',
            checkProductAvailability: false,
        };

        this.formTransition = {
            locationType: {
                Business: {
                    organizationName: {
                        label: 'Company Name',
                    },
                },
                POBox: {
                    address1: {
                        label: 'P.O. Box',
                    },
                    address2: {
                        label: 'Apartment/Suite/Other',
                    },
                },
                APOFPO: {
                    address1: {
                        label: 'Unit/Ship/PSC Number',
                    },
                    address2: {
                        label: 'Box/Hull Number',
                    },
                },
            },
            country: {
                US: {
                    state: {
                        label: 'State',
                        dropdownData: States.US,
                    },
                    zipCode: {
                        label: 'Zip Code',
                        max: 5,
                        inputType: 'AlphaNumeric',
                        inputFieldType: 'tel', // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
                    },
                },
                CA: {
                    state: {
                        label: 'Province',
                        dropdownData: States.CA,
                    },
                    zipCode: {
                        label: 'Postal Code',
                        min: 6,
                        max: 7,
                        inputType: 'AlphaNumericSpecial',
                        inputFieldType: 'text',
                    },
                },
            },
        };

        this.preFillAddressDetailsRecipient = this.preFillAddressDetailsRecipient.bind(this);
    }

    componentDidMount() {
        const {
            recipientAddress, updateFormFieldState,
            updateForm, clearErrors, formFieldState,
            actionsQasAddress, userType, loadAddressBook,
            isWriteScopeCheckout, validZip, subscription, recipientForm,
        } = this.props;
        const productPropertiesType = propertiesTypeByProduct[subscription.brand] || 'flower';
        const updateFieldState = { ...formFieldState };
        if (userType === 'R' && isWriteScopeCheckout) {
            loadAddressBook();
        }
        // updating city, state and country if zip is verified for wine subscription
        if (validZip?.length > 0) updateForm.triggerStateCityData(validZip);

        // if recipient address is present
        // update redux store with recipient address fields
        if (recipientAddress.firstName) {
            const recipientObject = {
                entryId: recipientAddress.entryId || '',
                addressId: recipientAddress.addressId || '',
                firstName: recipientAddress.firstName,
                lastName: recipientAddress.lastName,
                address1: recipientAddress.street1 || recipientAddress.address1,
                address2: recipientAddress.street2 || recipientAddress.address2,
                locationType: recipientAddress.businessTitle || recipientAddress.locationType,
                organizationName: recipientAddress.organizationName,
                state: recipientAddress.state,
                country: getCountryField(recipientAddress.country),
                zipCode: validZip || removeUSZipCodeSegment(recipientAddress.zipcode) || removeUSZipCodeSegment(recipientAddress.zipCode),
                phone: recipientAddress.telephoneNumber || recipientAddress.phone,
                city: recipientAddress.city,
                attentionText: recipientAddress.attentionText || '',
                phoneType: recipientAddress.phoneType || '',
                streetAddress3: recipientAddress.streetAddress3 || '',
            };
            if (productPropertiesType === 'food' && formFieldState.phone.required) {
                updateFieldState.phone.required = false;
                updateFieldState.phone.flagError = false;
                updateFieldState.phone.errorMessage = '';
            } else if (productPropertiesType !== 'food' && !formFieldState.phone.required) {
                updateFieldState.phone.required = true;
                updateFieldState.phone.flagError = false;
                updateFieldState.phone.errorMessage = '';
            }
            updateFormFieldState(updateFieldState, false, recipientForm, false);
            updateForm.updateFormAddressFromPreFill(recipientObject);
            if (recipientObject?.firstName) {
                this.resetRules(recipientObject);
            }
        } else {
            const recipientObject = {
                entryId: '',
                addressId: '',
                firstName: '',
                lastName: '',
                address1: '',
                address2: '',
                locationType: 'Residence',
                organizationName: '',
                state: '',
                country: '',
                zipCode: '',
                phone: '',
                city: '',
                attentionText: '',
                phoneType: '',
                streetAddress3: '',
            };

            updateForm.updateFormAddressFromPreFill(recipientObject);
            clearErrors({
                errType: 'recipientFormClearAllFields',
            });
        }
        // clear address verification state
        actionsQasAddress.resetQasAddressState();
    }

    componentDidUpdate() {
        const {
            recipientAddress,
            validateFormFields,
            recipientForm,
        } = this.props;
        const { initRender } = this.state;
        // Validates for the first time and only if First Name in Recipient Address is filled
        if (!initRender && recipientAddress.firstName) {
            this.setState({
                initRender: true,
            }, () => {
                validateFormFields(null, recipientForm, false);
            });
        }
    }

    isUsaOrCanada = (country) => ['USA', 'US', 'CA'].includes(country);

    onFormSubmit = (e) => {
        e.preventDefault();
        this.setState({ checkProductAvailability: true });
        this.handleRecipient('save');
    }

    setTextInputValue = async (event, validationResponse) => {
        const {
            clearErrors, updateForm, orderItemId,
            handleOnBlur, recipientForm, error,
        } = this.props;
        const { notAvailableCityObj } = this.state;
        const fieldName = event.target.name;
        const fieldValue = event.target.value;

        if (error[orderItemId]) {
            clearErrors({
                errType: 'recipientForm',
                field: orderItemId,
            });
        } else if (error[`${orderItemId}_productNotAvailable`]) {
            clearErrors({
                errType: 'recipientForm',
                field: `${orderItemId}_productNotAvailable`,
            });
        }

        clearErrors({
            errType: 'recipientForm',
            field: fieldName,
        });

        const fieldChangeObj = event;
        this.resetFormValueBasedOnFieldChange(fieldName, fieldValue);
        this.handleFormStateChanges(fieldName, fieldValue);

        // Don't allow first characte is space
        if (fieldChangeObj.target.value && fieldChangeObj.target.value === ' ') {
            fieldChangeObj.target.value = '';
        }

        if (fieldName === 'zipCode') this.setState({ isProductAvailable: '', checkProductAvailability: false });

        if (fieldName === 'city') {
            // Load CityList and State from Zipcode
            if (fieldValue.cityArray === null) {
                await updateForm.triggerStateCityData(recipientForm.zipCode);
            }

            let checkCity = false;
            if (fieldChangeObj.target.value !== 'CNS' && fieldValue.cityArray && fieldValue.cityArray.length > 0) {
                fieldValue.cityArray.map((city) => {
                    if (String(city).toLowerCase() === String(fieldChangeObj.target.value).toLowerCase()) {
                        checkCity = true;
                    }
                    return true;
                });
            }
            if (fieldChangeObj.target.value === notAvailableCityObj.key) {
                fieldChangeObj.target.value = '';
                this.setState({ notAvailableCity: true });
            } else if (checkCity) {
                fieldChangeObj.target.value = fieldChangeObj.target.value.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
                this.setState({ notAvailableCity: false });
            }
        }  else if (fieldName === 'address1' && fieldChangeObj.target.value) {
            // Important: This process is for dont allow the user add more 12 digits
            // in the address like the credit card in it.

            const addressValue = fieldChangeObj.target.value;

            // Get only  the number from the address
            const digitValues = addressValue.match(/\d/g);

            if (digitValues && digitValues.length > 12) {
                // Get the last digit position in the string
                let positionLastNumber = -1;
                Array.from(addressValue).forEach((value, index) => {
                    // the character is a digit, set the position
                    if (/^\d+$/.test(value)) {
                        positionLastNumber = index;
                    }
                });

                if (fieldChangeObj.target.value && positionLastNumber > 0
                    && fieldChangeObj.target.value.length > positionLastNumber
                ) {
                    // Get remove the last digit from the string and update the field address
                    const fieldUpdateValue = Array.from(addressValue);
                    delete fieldUpdateValue[positionLastNumber];
                    fieldChangeObj.target.value = fieldUpdateValue.join('');
                }
            }
        } else if (fieldName === 'country' && fieldValue) {
            const isCountryUSAorCanada = this.isUsaOrCanada(fieldValue);
            if (!isCountryUSAorCanada) {
                updateForm.updateRecipientForm({
                    state: 'OS',
                    zipCode: '00000',
                });
            }
        }

        await updateForm.updateForm(fieldChangeObj);
        if (validationResponse) {
            handleOnBlur(fieldName, validationResponse, recipientForm, null, updateForm.updateRecipientFormStatus);
        }
    }

    getStates = (states, firstEmpty = false) => {
        const { recipientForm } = this.props;
        let dropDownStates = { ...states };

        const selCountry = recipientForm.country;
        if (selCountry === 'US') {
            const tempStates = {};
            Object.keys(dropDownStates).forEach((sStates) => {
                if (recipientForm.locationType === 'APO/FPO' && dropDownStates[sStates].indexOf('Armed Forces') >= 0) {
                    tempStates[sStates] = dropDownStates[sStates];
                } else if (recipientForm.locationType !== 'APO/FPO' && dropDownStates[sStates].indexOf('Armed Forces') < 0) {
                    tempStates[sStates] = dropDownStates[sStates];
                }
                const city_array = ['apo', 'fpo'];
                const selectedCity = recipientForm.city?.toLowerCase();
                const APO_FPO_State = recipientForm.state && recipientForm.state in dropDownStates && city_array.includes(selectedCity) && dropDownStates[sStates].indexOf('Armed Forces') >= 0;

                if (APO_FPO_State) tempStates[sStates] = dropDownStates[sStates];
            });
            dropDownStates = tempStates;
        }
        if (firstEmpty) {
            dropDownStates =  { '': 'Select State', ...dropDownStates };
        }

        return Object.keys(dropDownStates).map((state) => (
            <MenuItem key={state} value={state} data-test={`subscription-recipient-states-dropdown-option-${state}`}>
                {dropDownStates[state]}
            </MenuItem>
        ));
    }

    getCountries = () => {
        const countryList = defaultCountryList;
        return countryList.map((country) => (
            <MenuItem
                data-test={`${'subscription-recipient-country-dropdown-option-'}${country.key}`}
                key={country.key}
                value={country.key}
            >
                {country.value}
            </MenuItem>
        ));
    }

    getLocationTypes = () => {
        const { subscription } = this.props;
        const locationTypes = getListLocationTypes(propertiesTypeByProduct[subscription.brand]);
        return locationTypes.map((location) => (
            <MenuItem data-test={`${'subscription-recipient-locationType-value-'}${location.key}`} key={location.key} value={location.value}>
                {location.value}
            </MenuItem>
        ));
    }

    getAPOFPOModalInfo = () => {
        const { openModelApoInfo } = this.state;
        const { classes } = this.props;
        return (
            <Modal
                aria-labelledby="apofpo-modal-title"
                aria-describedby="apofpo-modal-description"
                open={openModelApoInfo}
                onClose={this.handleApoToggle}
            >
                <div className={classes.apoInfoPaper}>
                    <Typography component="span" variant="h6" id="apofpo-modal-title">
                        APO/FPO Address Help.
                    </Typography>
                    <Typography component="span" variant="subtitle1" id="apofpo-modal-description">
                        When ordering, choose APO/FPO MILITARY and select from the Armed Forces delivery locations within the State drop down menu field. Please allow at least 5 weeks transit time for delivery.
                    </Typography>
                </div>
            </Modal>
        );
    }

    getAPOFPO = () => ['APO', 'FPO'].map((PO) => (
        <MenuItem key={PO} value={PO}>
            {PO}
        </MenuItem>
    ))

    renderCity = (cityArray) => {
        const cityMapped = [];
        if (cityArray.length > 0) {
            cityArray.forEach((city) => (
                cityMapped.push({
                    key: city.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()),
                    value: city.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()),
                })
            ));
        }
        cityMapped.push({
            key: 'CNS',
            value: 'City Not Shown',
        });
        return cityMapped;
    };

    getFieldLabel = (formTransition, fieldName, defaultLabel) => (
        (Object.prototype.hasOwnProperty.call(formTransition, fieldName)) ? formTransition[fieldName].label : defaultLabel
    )

    handleFieldFocus = (event) => {
        if (event.target.name === 'address1') {
            const updateState = { ...this.state };
            updateState.addressSearch.focus = true;
            updateState.addressSearch.valueOnKeyUp = event.target.value;
            this.setState(updateState);
        }
    }

    handleAddressSearchBlur = () => {
        const updateState = { ...this.state };
        updateState.addressSearch.focus = false;
        updateState.addressSearch.valueOnKeyUp = '';
        this.setState(updateState);
    }

    handleOnKeyUp = (event) => {
        if (event.target.name === 'address1') {
            const updateState = { ...this.state };
            updateState.addressSearch.valueOnKeyUp = event.target.value;
            this.setState(updateState);
        }
    }

    isInputFilled = (key, response) => {
        const { recipientForm, handleOnBlur, updateForm } = this.props;
        handleOnBlur(key, response, recipientForm, null, updateForm.updateRecipientFormStatus);
    }

    recipientBuilder = (recipientForm) => {
        const recipientObject = {};
        Object.keys(recipientForm)
            .filter((key) => !key.includes('giftMessage'))
            .filter((key) => !key.includes('entryId'))
            .map((objectKey) => {
                recipientObject[objectKey] = recipientForm[objectKey];
                return null;
            });
        return recipientObject;
    }

    resetRules = (recipientData) => {
        const { recipientForm } = this.props;
        const recipient = recipientData || recipientForm;
        this.handleFormStateChanges('locationType', recipient.locationType);
        this.handleFormStateChanges('country', recipient.country);
    }

    hasError = (fields) => Object.entries(fields).some((field) => field[1].required && field[1].flagError);

    // isAddressVerified: U - Unverified || V - Verified || O - Overwrite
    handleRecipient = async (actionType, dpvIndicator = 'N', isAddressVerified = 'U', overWriteAddress) => {
        const {
            flags, recipientForm, orderItemId, recipientAddress, formFieldState, featureFlags, error,
            closeForm, handleRecipientSubmit, updateSubscriptionReduxList, subscription, membershipType,
            searchVerifyAddress, hasQasFailed, ruleId, subscriptionRecipientForm, customerId, brand,
        } = this.props;
        const { useAddressForAll, checkSameAsDeliveryAddress } = this.state;
        const recipient = { ...recipientForm };

        recipient.street3 = recipientAddress?.street3 || '';
        recipient.phoneType = recipientAddress?.phoneType || 'HP';
        recipient.attentionText = recipientAddress?.attentionText || '';
        const recipientFormData = this.recipientBuilder(recipient);

        if (featureFlags['enable-sup-availability-check'] && (!(await productAvailability(
            subscription,
            subscription.productId,
            recipientFormData.zipCode,
            membershipType,
            (status) => this.setState({ isProductAvailable: status }),
            (status) => this.setState({ checkProductAvailability: status }),
        )) || error.zipCode)) return;

        if (!ruleId) {
            delete recipientFormData.addressId;
        }
        const isCountryUSAorCanada = this.isUsaOrCanada(recipientFormData.country);

        // International Product
        if (!isCountryUSAorCanada) {
            recipientFormData.state = 'OS';
            recipientFormData.zipCode = '00000';
        }

        const data = {
            orderItemId,
            recipient: recipientFormData,
            entryId: recipient.entryId,
            ruleId,
            checkSameAsDeliveryAddress,
            useAddressForAll,
            dpvIndicator,
            isAddressVerified,
            closeForm,
            customerId,
            flags,
            brand,
        };
        if (this.hasError(formFieldState)) return;
        if (!formFieldState.zipCode.flagError) {
            if (flags['is-qas-address-verification-enabled'] && !hasQasFailed && isCountryUSAorCanada) {
                if (actionType === 'qasAddressSelection') {
                    data.recipient.address1 = overWriteAddress.addressLine1;
                    data.recipient.address2 = overWriteAddress.addressLine2;
                    data.recipient.city = overWriteAddress.city;
                    data.recipient.country = overWriteAddress.country;
                    data.recipient.state = overWriteAddress.state;
                    data.recipient.zipCode = overWriteAddress.zipCode || overWriteAddress.zipcode;
                    data.recipient.useAddressForAll = useAddressForAll;
                    data.recipient.checkSameAsDeliveryAddress = checkSameAsDeliveryAddress;
                    subscriptionRecipientForm(data);
                    updateSubscriptionReduxList(data.recipient);
                } else if (actionType === 'keep') {
                    subscriptionRecipientForm(data);
                    updateSubscriptionReduxList(data.recipient);
                } else if (actionType === 'save') {
                    searchVerifyAddress({ data });
                    this.setState((prevState) => ({ ...prevState, oldRecipientData: recipientAddress }));
                    updateSubscriptionReduxList(data.recipient);
                    handleRecipientSubmit(data.recipient);
                }
            } else {
                subscriptionRecipientForm(data);
                updateSubscriptionReduxList(data.recipient);
            }
        }
    }

    showAddress2 = () => {
        const { showAddress2 } = this.state;
        this.setState({ showAddress2: !showAddress2 });
    }

    handleUseAsBilling = () => {
        const { checkSameAsDeliveryAddress } = this.state;
        this.setState({ checkSameAsDeliveryAddress: !checkSameAsDeliveryAddress });
        const { recipientForm, updateForm } = this.props;
        const updateFieldValues = { ...recipientForm };
        updateFieldValues.checkSameAsDeliveryAddress = !checkSameAsDeliveryAddress;
        updateForm.updateFormAddressFromPreFill(updateFieldValues);
    }

    handleShipAllGiftsToThisAddress = () => {
        const { useAddressForAll } = this.state;
        this.setState({ useAddressForAll: !useAddressForAll });

        const { recipientForm, updateForm } = this.props;
        const updateFieldValues = { ...recipientForm };
        updateFieldValues.useAddressForAll = !useAddressForAll;
        updateForm.updateFormAddressFromPreFill(updateFieldValues);
    }

    resetFormValueBasedOnFieldChange = (fieldName, fieldValue) => {
        const { recipientForm, updateForm } = this.props;
        const updateFieldValues = { ...recipientForm };
        let update = false;
        if (fieldName === 'locationType') {
            updateFieldValues.state = '';
            updateFieldValues.city = '';
            updateFieldValues.zipCode = '';
            updateFieldValues.organizationName = '';
            update = true;
        }
        if (fieldName === 'country') {
            updateFieldValues.state = '';
            updateFieldValues.zipCode = '';
            updateFieldValues.city = '';
            update = true;
        }
        if (fieldName === 'address1' && fieldValue.toString().length === 0) {
            updateFieldValues.address2 = '';
            updateFieldValues.city = '';
            updateFieldValues.state = '';
            updateFieldValues.country = '';
            updateFieldValues.zipCode = '';
        }
        if (update) {
            updateForm.updateFormAddressFromPreFill(updateFieldValues);
        }
    }

    handleFormStateChanges = async (fieldName, fieldValue) => {
        const {
            recipientForm, updateFormFieldState, formFieldState, updateForm,
        } = this.props;
        const formChange = { ...formFieldState };
        if (fieldName === 'locationType') {
            if (!['Residence', 'Apartment', 'POBox'].includes(fieldValue)) {
                formChange.organizationName.required = true;
            } else if (fieldValue === 'APO/FPO') {
                formChange.address2.required = true;
                formChange.city.required = true;
                formChange.state.required = true;
                formChange.organizationName.required = false;
            } else {
                formChange.organizationName.required = false;
                formChange.organizationName.flagError = false;
                formChange.organizationName.errorMessage = '';
                formChange.organizationName.alert = false;
                formChange.address2.required = false;
                formChange.address2.flagError = false;
                formChange.address2.errorMessage = '';
                formChange.city.required = true;
                formChange.city.errorMessage = '';
                this.handleFormStateChanges('country', recipientForm.country);
            }
        } else if (fieldName === 'country') {
            if (fieldValue === 'US' || fieldValue === 'CA') {
                formChange.state.required = true;
                formChange.zipCode.required = true;
            } else {
                formChange.state.required = false;
                formChange.state.flagError = false;
                formChange.state.errorMessage = '';
                formChange.zipCode.required = false;
                formChange.zipCode.flagError = false;
                formChange.zipCode.errorMessage = '';
            }
        } else if (fieldName === 'zipCode') {
            if (fieldValue.length >= 5) {
                await updateForm.triggerStateCityData(fieldValue);
            } else if (fieldValue.length === 0) {
                updateForm.updateRecipientForm({
                    state: 'AL',
                    city: '',
                    cityArray: [],
                });
            }
        }

        updateFormFieldState(formChange, ['address1', 'address2'], recipientForm, false);
    }

    handleApoToggle = () => {
        const { openModelApoInfo } = this.state;
        this.setState({ openModelApoInfo: !openModelApoInfo });
    };

    removeSpecialChar = (str) => {
        if (str) return str.replace(/[^a-zA-Z]+/g, '');
        return '';
    };

    isNumeric = (value) => !Number.isNaN(value) && !Number.isNaN(parseFloat(value))

    cleanString = (str) => {
        const strVal = str || '';
        return strVal.trim();
    }

    handleSelectedAddressBook = async (address) => {
        const {
            recipientForm, updateForm, validateFormFields, userType,
        } = this.props;
        if (userType === 'G') {
            if (address) {
                const profile = address;
                const updateRecipientForm = {
                    firstName: this.cleanString(profile.firstName),
                    lastName: this.cleanString(profile.lastName),
                    address1: this.cleanString(profile.address1),
                    address2: this.cleanString(profile.address2),
                    locationType: this.cleanString(profile.locationType),
                    organizationName: this.cleanString(profile.organizationName),
                    state: this.cleanString(profile.state),
                    country: this.cleanString(profile.country),
                    zipCode: this.cleanString(profile.zipCode),
                    phone: this.cleanString(profile.phone),
                    city: this.cleanString(profile.city),
                };
                await updateForm.updateFormAddressFromPreFill(updateRecipientForm);
                this.resetRules();
                const fieldsToValidate = ['firstName', 'lastName', 'address1', 'address2', 'organizationName', 'locationType', 'state', 'country', 'zipCode', 'phone', 'city'];
                validateFormFields(fieldsToValidate, recipientForm, false);
            }
        } else if (userType === 'R') {
            if (address && address.AddressBookEntryId) {
                const profile = address;
                const addresses = profile.Addresses?.[0];
                if (addresses) {
                    const tempPostCode = this.cleanString(addresses.PostalCode);
                    const postalCode = tempPostCode?.split('-')[0];
                    const updateRecipientForm = {
                        entryId: profile.AddressBookEntryId,
                        addressId: addresses.AddressId,
                        firstName: this.cleanString(profile.FirstName),
                        lastName: this.cleanString(profile.LastName),
                        address1: this.cleanString(addresses.AddressLineOne),
                        address2: this.cleanString(addresses.AddressLineTwo),
                        locationType: this.cleanString(addresses.AddressType),
                        organizationName: this.cleanString(addresses.AddressDescription),
                        state: this.cleanString(addresses.StateProvince),
                        country: this.cleanString(addresses.Country),
                        zipCode: postalCode,
                        phone: this.cleanString(profile.PhoneNumber),
                        city: this.cleanString(addresses.City),
                    };
                    await updateForm.updateFormAddressFromPreFill(updateRecipientForm);
                    this.resetRules();
                    const fieldsToValidate = ['firstName', 'lastName', 'address1', 'address2', 'organizationName', 'locationType', 'state', 'country', 'zipCode', 'phone', 'city'];
                    validateFormFields(fieldsToValidate, recipientForm, false);
                }
            }
        }
    }

    // The return need to be a boolean
    getFlagError = (localFieldState, serverFieldState) => {
        if (localFieldState.flagError || serverFieldState) {
            return true;
        }
        return false;
    }

    useQasAddressSearch = () => {
        const { flags, hasQasFailed } = this.props;
        if (flags['is-qas-address-suggestions-enabled'] && !hasQasFailed) {
            return true;
        }
        return false;
    }

    useGoogleAddressSearch = () => {
        const { flags, hasQasFailed, recipientForm } = this.props;
        if (flags['is-google-places-enabled']
        || (flags['is-qas-address-suggestions-enabled'] && hasQasFailed && this.isUsaOrCanada(recipientForm.country))) {
            return true;
        }
        return false;
    }

    preFillAddressDetailsRecipient(data) {
        const { useAddressForAll, checkSameAsDeliveryAddress } = this.state;
        const { recipientForm, updateForm, validateFormFields } = this.props;
        const updateRecipientForm = {
            ...recipientForm,
            address1: data.addressLine1,
            address2: data.addressLine2,
            zipCode: data.zipcode,
            city: data.city,
            state: data.state,
            country: data.country,
            useAddressForAll,
            checkSameAsDeliveryAddress,
        };
        updateForm.updateFormAddressFromPreFill(updateRecipientForm);

        if (updateRecipientForm.zipCode) {
            updateForm.triggerStateCityData(updateRecipientForm.zipCode);
        }

        const fieldsToValidate = ['address1', 'address2', 'city', 'state', 'country', 'zipCode'];
        validateFormFields(fieldsToValidate, updateRecipientForm, false);
    }

    handleCloseForm = () => {
        const { oldRecipientData } = this.state;
        const { closeForm, handleRecipientSubmit, updateSubscriptionReduxList } = this.props;
        if (!isEmpty(oldRecipientData)) {
            handleRecipientSubmit(oldRecipientData);
            updateSubscriptionReduxList(oldRecipientData);
        }
        closeForm('close');
    };

    render() {
        const {
            classes, recipientForm, flags, getTextFieldProps, addressBookEntries,
            loadAddressBook, addressBookPageOn, addressBookTotalPages, totalAddresses,
            formFieldState, error, totalOrderItems, orderItemId,
            userType, validZip, subscription, featureFlags,
        } = this.props;

        const {
            addressSearch, useAddressForAll, address2Display,
            notAvailableCityObj, notAvailableCity, checkProductAvailability, isProductAvailable,
        } = this.state;

        const enableSupAvailabilityCheck = featureFlags['enable-sup-availability-check'] || false;

        const cityArray = (recipientForm.cityArray) ? recipientForm.cityArray : [];
        const selCountry = recipientForm.country || '';
        const isCountryUSAorCanada = this.isUsaOrCanada(selCountry);
        const formTransitionCountry = this.formTransition.country[selCountry] || {};
        const hasCompanyName = recipientForm?.organizationName || '';
        const errorCompanyName =  error?.organizationName || '';
        const errorPhoneNumber = error?.phone || '';
        const countryList = this.getCountries();
        const productPropertiesType = propertiesTypeByProduct[subscription.brand] || 'flower';
        const listProperties = getInputProperties(productPropertiesType);
        const location_type = this.isNumeric(recipientForm.locationType) ? getLocationType(recipientForm.locationType) : recipientForm.locationType;
        const sanitizedLocation = ['APO/FPO', 'P.O. Box'].includes(location_type)
            ? this.removeSpecialChar(location_type)
            : location_type;

        const fieldLabelProps = listProperties[sanitizedLocation]?.formFieldLabels || listProperties.Residence.formFieldLabels;

        let isPoBox = false;
        let PoBoxAddressLine1 = '';
        if (sanitizedLocation.includes('POBox')) {
            isPoBox = true;
            const PoBox = recipientForm.address1.slice(7, 13).toLowerCase();
            if ((/(po)(\s|box)+/g).test(PoBox)) {
                PoBoxAddressLine1 = recipientForm.address1.replace('PO Box', '').trim();
            } else {
                PoBoxAddressLine1 = recipientForm.address1;
            }
        }

        return (
            <Card className={classes.scrollStyle} id={`subscription-${orderItemId}`} elevation={0}>
                <Grid container className={classes.cardHeaderWrap}>
                    <Grid item xs={10}>
                        <Typography component="span">
                            <CardHeader
                                data-test="checkout-recipient-header"
                                title="RECIPIENT ADDRESS"
                                classes={{
                                    root: classes.cardHeaderRoot,
                                    title: classes.cardHeaderTitle,
                                }}
                            />
                        </Typography>
                    </Grid>
                    <Grid container item xs={2} justify="flex-end">
                        <IconButton
                            aria-label="delete"
                            align="right"
                            data-test="checkout-recipient-form-close"
                            data-testid="checkout-recipient-form-close"
                            id="recipientFormCloseLink"
                            onClick={this.handleCloseForm}
                            onKeyPress={this.handleCloseForm}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
                <CardContent className={classes.formContainer}>
                    <form onSubmit={this.onFormSubmit}>
                        <Grid container spacing={8}>
                            {(flags['is-qas-address-verification-enabled'] && isCountryUSAorCanada) && <QasAddressVerificationModal handleSaveAddress={this.handleRecipient} />}
                            {(isCountryUSAorCanada && userType === 'R' && addressBookEntries.length > 0) && (
                                <Grid item xs={12} className={classes.marginBottomSpace}>
                                    <AddressBookWithPagination
                                        name="addressBook"
                                        entries={addressBookEntries}
                                        selectedAddress={this.handleSelectedAddressBook}
                                        loadAddressBook={loadAddressBook}
                                        pageOn={addressBookPageOn}
                                        noOfPages={addressBookTotalPages}
                                        totalAddresses={totalAddresses}
                                        totalOrderItems={totalOrderItems}
                                        handleShipAllGifts={this.handleShipAllGiftsToThisAddress}
                                        valueUseAddressForAll={useAddressForAll}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} className={`${classes.dropDownView} ${classes.marginBottomSpace}`}>
                                <TextFieldWrapper
                                    label={fieldLabelProps.locationType}
                                    id="subscriptionFormLocationType"
                                    name="locationType"
                                    borderedSelect
                                    flagError={this.getFlagError(formFieldState.locationType, error.locationType)}
                                    errorMessage={error.locationType || formFieldState.locationType.errorMessage}
                                    val={recipientForm.locationType ? location_type : 'Business'}
                                    dropdown={this.getLocationTypes()}
                                    isInputFilled={this.isInputFilled}
                                    setTextInputState={this.setTextInputValue}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping location-type"
                                />
                            </Grid>
                            <Grid item xs={12} className={`${classes.marginBottomSpace} ${classes.inputText}`}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextFieldWrapper
                                            name="firstName"
                                            id="subscriptionFormFirstName"
                                            inputType="Alphabets"
                                            label={fieldLabelProps.firstName}
                                            flagError={this.getFlagError(formFieldState.firstName, error.firstName)}
                                            errorMessage={error.firstName || formFieldState.firstName.errorMessage}
                                            required={formFieldState.firstName.required}
                                            max={14}
                                            val={recipientForm.firstName}
                                            isInputFilled={this.isInputFilled}
                                            setTextInputState={this.setTextInputValue}
                                            returnFieldProps={getTextFieldProps}
                                            autoComplete="section-shipping given-name"
                                        />
                                    </Grid>
                                    <Grid item xs={6} className={classes.inputText}>
                                        <TextFieldWrapper
                                            name="lastName"
                                            id="subscriptionFormLastName"
                                            inputType="Alphabets"
                                            label={fieldLabelProps.lastName}
                                            required={formFieldState.lastName.required}
                                            flagError={this.getFlagError(formFieldState.lastName, error.lastName)}
                                            errorMessage={error.lastName || formFieldState.lastName.errorMessage}
                                            val={recipientForm.lastName}
                                            max={14}
                                            isInputFilled={this.isInputFilled}
                                            setTextInputState={this.setTextInputValue}
                                            returnFieldProps={getTextFieldProps}
                                            autoComplete="section-shipping family-name"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            {(!!fieldLabelProps.organizationName || Object.keys(this.formTransition.locationType).indexOf(recipientForm?.locationType) >= 0 || hasCompanyName?.length > 0) && (
                                <Grid item xs={12} className={classes.marginBottomSpace}>
                                    <TextFieldWrapper
                                        label={fieldLabelProps.organizationName}
                                        name="organizationName"
                                        id="recipientFormOrganizationName"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        flagError={this.getFlagError(formFieldState.organizationName, errorCompanyName)}
                                        errorMessage={error.organizationName || formFieldState.organizationName.errorMessage}
                                        required={formFieldState.organizationName.required}
                                        max={30}
                                        val={recipientForm.organizationName}
                                        isInputFilled={this.isInputFilled}
                                        setTextInputState={this.setTextInputValue}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping organization"
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} className={classes.marginBottomSpace}>
                                {/* Address Search - Google Start */}
                                {(this.useGoogleAddressSearch()) && (
                                    <GoogleAddressSearch
                                        getPreFillAddressDetails={this.preFillAddressDetailsRecipient}
                                        searchId="recipient-address-line1"
                                    >
                                        <TextFieldWrapper
                                            label={fieldLabelProps.address1}
                                            id="subscription-address-line1"
                                            key="recipientAddressSearchTF"
                                            name="address1"
                                            inputType="AlphaNumericSpecial"
                                            fullWidth
                                            required={formFieldState.address1.required}
                                            flagError={this.getFlagError(formFieldState.address1, error.address1)}
                                            errorMessage={error.address1 || formFieldState.address1.errorMessage}
                                            val={isPoBox ? PoBoxAddressLine1 : recipientForm.address1}
                                            max={100}
                                            isInputFilled={this.isInputFilled}
                                            setTextInputState={this.setTextInputValue}
                                            returnFieldProps={getTextFieldProps}
                                            autoComplete="section-shipping address-line1"
                                        />
                                    </GoogleAddressSearch>
                                )}
                                {/* Address Search - Google End */}
                                {/* Address Verification Search - QAS Start */}
                                {(this.useQasAddressSearch() && isCountryUSAorCanada) && (
                                    <AddressVerificationSearch
                                        searchId="subscription-address-line1"
                                        searchText={addressSearch.valueOnKeyUp}
                                        searchTextFocus={addressSearch.focus}
                                        onBlurHandler={this.handleAddressSearchBlur}
                                        getPreFillAddressDetails={this.preFillAddressDetailsRecipient}
                                        useGeoLocation={flags['is-qas-geo-location-enabled']}
                                        zipCode={recipientForm.zipCode}
                                        isValidZipCode={!(error.zipCode || formFieldState.zipCode.errorMessage)}
                                        state={recipientForm.state}
                                        countryCode={recipientForm.country}
                                    >
                                        <TextFieldWrapper
                                            label={fieldLabelProps.address1}
                                            id="subscription-address-line1"
                                            key="recipientAddressSearchTF"
                                            name="address1"
                                            inputType="AlphaNumericSpecial"
                                            fullWidth
                                            required={formFieldState.address1.required}
                                            flagError={this.getFlagError(formFieldState.address1, error.address1)}
                                            errorMessage={error.address1 || formFieldState.address1.errorMessage}
                                            val={isPoBox ? PoBoxAddressLine1 : recipientForm.address1}
                                            max={100}
                                            handleOnFocus={this.handleFieldFocus}
                                            handleOnKeyUp={this.handleOnKeyUp}
                                            isInputFilled={this.isInputFilled}
                                            setTextInputState={this.setTextInputValue}
                                            returnFieldProps={getTextFieldProps}
                                            autoComplete="section-shipping address-line1"
                                        />
                                    </AddressVerificationSearch>
                                )}
                                {/* Address Verification Search - QAS End */}
                                {((!flags['is-google-places-enabled'] && !flags['is-qas-address-suggestions-enabled'] && isCountryUSAorCanada)
                                    || (!flags['is-google-places-enabled'] && !isCountryUSAorCanada)) && (
                                    <TextFieldWrapper
                                        label={fieldLabelProps.address1}
                                        id="subscription-address-line1"
                                        key="recipientAddressSearchTF"
                                        name="address1"
                                        inputType="AlphaNumericSpecial"
                                        fullWidth
                                        required={formFieldState.address1.required}
                                        flagError={this.getFlagError(formFieldState.address1, error.address1)}
                                        errorMessage={error.address1 || formFieldState.address1.errorMessage}
                                        val={recipientForm.address1}
                                        max={100}
                                        isInputFilled={this.isInputFilled}
                                        setTextInputState={this.setTextInputValue}
                                        returnFieldProps={getTextFieldProps}
                                        autoComplete="section-shipping address-line1"
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} item className={`${classes.divFullRow} ${classes.marginBottomSpace}`} style={{ display: address2Display }}>
                                <TextFieldWrapper
                                    /* label="Delivery Address Line 2" */
                                    label={fieldLabelProps.address2}
                                    name="address2"
                                    id="subscriptionFormAddress2"
                                    inputType="AlphaNumericSpecial"
                                    fullWidth
                                    required={formFieldState.address2.required}
                                    flagError={formFieldState.address2.flagError}
                                    errorMessage={formFieldState.address2.errorMessage}
                                    val={recipientForm.address2}
                                    max={30}
                                    isInputFilled={this.isInputFilled}
                                    setTextInputState={this.setTextInputValue}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping address-line2"
                                />
                            </Grid>
                            <Grid item xs={12} className={classes.marginBottomSpace}>
                                <Grid container spacing={2}>
                                    {((recipientForm.country === 'US') || (recipientForm.country === 'CA')) && (
                                        <Grid item xs={6}>
                                            <TextFieldWrapper
                                                disabled={validZip.length > 0}                  // disabling the field for verified zipcode for wine subscription
                                                label={formTransitionCountry.zipCode.label}
                                                name="zipCode"
                                                id="subscriptionFormZipCode"
                                                inputType={formTransitionCountry.zipCode.inputType}
                                                inputFieldType={formTransitionCountry.zipCode.inputFieldType}
                                                validateRule="ZipCode"
                                                required={formFieldState.zipCode.required}
                                                flagError={this.getFlagError(formFieldState.zipCode, error.zipCode)}
                                                errorMessage={error.zipCode || formFieldState.zipCode.errorMessage}
                                                val={recipientForm.zipCode}
                                                max={formTransitionCountry.zipCode.max}
                                                isInputFilled={this.isInputFilled}
                                                setTextInputState={this.setTextInputValue}
                                                returnFieldProps={getTextFieldProps}
                                                autoComplete="section-shipping postal-code"
                                            />
                                        </Grid>
                                    )}
                                    {((recipientForm.country === 'US') || (recipientForm.country === 'CA')) && (
                                        <Grid item xs={6} className={`${classes.stateField} ${classes.dropDownView}`}>
                                            <TextFieldWrapper
                                                disabled={validZip.length > 0}                  // disabling the field for verified zipcode for wine subscription
                                                label={formTransitionCountry.state.label}
                                                name="state"
                                                id="subscriptionFormState"
                                                nativeSelect
                                                required={formFieldState.state.required}
                                                flagError={this.getFlagError(formFieldState.state, error.state)}
                                                errorMessage={error.state || formFieldState.state.errorMessage}
                                                val={this.getStates(formTransitionCountry.state.dropdownData, true).some((x) => x.key === recipientForm.state) ? recipientForm.state : ''}
                                                dropdown={this.getStates(formTransitionCountry.state.dropdownData, true)}
                                                isInputFilled={this.isInputFilled}
                                                setTextInputState={this.setTextInputValue}
                                                returnFieldProps={getTextFieldProps}
                                                autoComplete="section-shipping address-level1"
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={classes.marginBottomSpace}>
                                <Grid container spacing={2}>
                                    {recipientForm.locationType === 'APO/FPO' && (
                                        <Grid item xs={6}>
                                            <TextFieldWrapper
                                                /* label="Delivery Address Line 2" */
                                                disabled={validZip.length > 0}                  // disabling the field for verified zipcode for wine subscription
                                                label="APO/FPO:"
                                                name="city"
                                                data-test="subscription-recipient-form-field-city"
                                                id="subscriptionFormCityAPO"
                                                borderedSelect
                                                required={formFieldState.city.required}
                                                flagError={this.getFlagError(formFieldState.city, error.city)}
                                                errorMessage={error.city || formFieldState.city.errorMessage}
                                                val={this.getAPOFPO().some((x) => x.key?.toLowerCase() === recipientForm.city?.toLowerCase()) ? (recipientForm.city).toUpperCase() : ''}
                                                dropdown={this.getAPOFPO()}
                                                isInputFilled={this.isInputFilled}
                                                setTextInputState={this.setTextInputValue}
                                                returnFieldProps={getTextFieldProps}
                                                autoComplete="section-shipping country"
                                            />
                                            <Grid item xs={12} className={classes.apoLink}>
                                                <span
                                                    className={classes.apoHelpLink}
                                                    id="subscriptionFormAPIHelpLink"
                                                    onClick={this.handleApoToggle}
                                                    onKeyDown={this.handleApoToggle}
                                                    role="link"
                                                    tabIndex={0}
                                                >
                                                    Help with an APO/FPO
                                                </span>
                                            </Grid>
                                            {this.getAPOFPOModalInfo()}
                                        </Grid>
                                    )}
                                    {
                                        recipientForm.locationType !== 'APO/FPO' && cityArray.length > 0
                                            ? (
                                                <Grid item xs={6} className={classes.citySelect}>
                                                    <TextFieldWrapper
                                                        customSelect
                                                        disabled={validZip.length > 0}                  // disabling the field for verified zipcode for wine subscription
                                                        label="City"
                                                        defaultValue={null}
                                                        name="city"
                                                        inputType="Alphabets"
                                                        flagError={this.getFlagError(formFieldState.city, error.city)}
                                                        errorMessage={error.city || formFieldState.city.errorMessage}
                                                        required={formFieldState.city.required}
                                                        variant="outlined"
                                                        dropdown={this.renderCity(cityArray)}
                                                        val={recipientForm.city}
                                                        max={200}
                                                        isInputFilled={this.isInputFilled}
                                                        setTextInputState={this.setTextInputValue}
                                                        returnFieldProps={getTextFieldProps}
                                                        showIntputBox={notAvailableCity}
                                                        showDefaultDropDownValue={notAvailableCityObj.key}
                                                        autoComplete="shipping address-level2"
                                                    />
                                                </Grid>
                                            )
                                            : null
                                    }
                                    {
                                        recipientForm.locationType !== 'APO/FPO' && cityArray.length === 0
                                            ? (
                                                <Grid item xs={6} className={classes.citySelect}>
                                                    <TextFieldWrapper
                                                        disabled={validZip.length > 0}                  // disabling the field for verified zipcode for wine subscription
                                                        id="subscriptionFormCity"
                                                        label="City"
                                                        name="city"
                                                        borderedInput
                                                        inputType="Alphabets"
                                                        flagError={this.getFlagError(formFieldState.city, error.city)}
                                                        errorMessage={error.city || formFieldState.city.errorMessage}
                                                        required={formFieldState.city.required}
                                                        variant="outlined"
                                                        val={recipientForm.city}
                                                        max={20}
                                                        isInputFilled={this.isInputFilled}
                                                        setTextInputState={this.setTextInputValue}
                                                        returnFieldProps={getTextFieldProps}
                                                        autoComplete="section-shipping address-level2"
                                                    />
                                                </Grid>
                                            )
                                            : null
                                    }
                                    <Grid item xs={6} className={`${classes.countryField}  ${classes.dropDownView}`}>
                                        <TextFieldWrapper
                                            label="Country"
                                            name="country"
                                            id="subscriptionFormCountry"
                                            borderedSelect
                                            disabled={countryList.length === 1 || validZip.length > 0}
                                            required={formFieldState.country.required}
                                            flagError={formFieldState.country.flagError}
                                            errorMessage={formFieldState.country.errorMessage}
                                            val={recipientForm.country}
                                            dropdown={countryList}
                                            isInputFilled={this.isInputFilled}
                                            setTextInputState={this.setTextInputValue}
                                            returnFieldProps={getTextFieldProps}
                                            autoComplete="section-shipping country"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={classes.marginBottomSpace}>
                                <TextFieldWrapper
                                    label="Recipient Telephone"
                                    name="phone"
                                    id="subscriptionFormPhone"
                                    inputFieldType="tel" // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
                                    inputType="Phone"
                                    validateRule="Phone"
                                    maskInput="Phone"
                                    fullWidth
                                    required={formFieldState.phone.required}
                                    flagError={this.getFlagError(formFieldState.phone, errorPhoneNumber)}
                                    errorMessage={error.phone || formFieldState.phone.errorMessage}
                                    val={recipientForm.phone}
                                    min={10}
                                    max={20}
                                    isInputFilled={this.isInputFilled}
                                    setTextInputState={this.setTextInputValue}
                                    returnFieldProps={getTextFieldProps}
                                    autoComplete="section-shipping tel"
                                />
                            </Grid>
                            {this.state.isProductAvailable === 'not_available'
                            && (
                                <Grid item xs={12} className={classes.marginBottomSpace}>
                                    <div style={{ color: 'red', padding: '10px 10px 25px', textAlign: 'center' }}>We are sorry, the product is not available for the zipcode that you have entered. Please enter another zipcode.</div>
                                </Grid>
                            )}
                            {/* ACTION BUTTONS */}
                            <Grid item xs={12}>
                                <Grid container spacing={2} className={isProductAvailable !== 'not_available' && classes.actionButtonRow} item xs={12} justify="center">
                                    <Grid item xs={6} md={3}>
                                        <Button
                                            variant="contained"
                                            data-test="subscription-recipient-form-cancel"
                                            id="subscriptionFormCancelButton"
                                            onClick={this.handleCloseForm}
                                            color="secondary"
                                            fullWidth
                                            className={classes.secondaryButtonStyle}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            data-testid="subscription-recipient-form-save"
                                            id="subscriptionFormSaveButton"
                                            fullWidth
                                            className={classes.primaryButtonStyle}
                                        >
                                            Save
                                            {enableSupAvailabilityCheck && checkProductAvailability && <CircularProgress style={{ color: 'white', marginLeft: '10px' }} thickness={7} size="14px" />}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => ({
    totalOrderItems: commonSelectors.getNoOfOrderItems(state),
    recipientForm: commonSelectors.getRecipientForm(state),
    error: commonSelectors.getRecipientFormError(state),
    addressBookEntries: getAddressBookEntries(state),
    userType: getUserType(state),
    addressBookTotalPages: getTotalNoOfPages(state),
    addressBookPageOn: getAddressBookPageNumber(state),
    totalAddresses: getTotalEntriesAddressBook(state),
    flags: getFlags(state),
    hasQasFailed: getHasQasFailed(state),
    brand: getBrand(state),
    isWriteScopeCheckout: getIsWriteScopeCheckout(state),
    membershipType: getMembershipType(state),
    featureFlags: getFeatureFlags(state),
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: bindActionCreators(recipientFormActions, dispatch),
    clearErrors: bindActionCreators(errorActions.clearErrors, dispatch),
    loadAddressBook: bindActionCreators(loadAddressBookAction, dispatch),
    actionsQasAddress: bindActionCreators(qasAddressSearchActions, dispatch),
    subscriptionRecipientForm: (data) => dispatch(EventDispatcher.updateSubscriptionRecipientForm(data)),
    searchVerifyAddress: bindActionCreators(subscriptionVerifyAddress, dispatch),
});

SubscriptionRecipientForm.propTypes = {
    recipientForm: object.isRequired,
    orderItemId: string.isRequired,
    updateForm: object.isRequired,
    recipientAddress: object.isRequired,
    closeForm: func.isRequired,
    classes: object.isRequired,
    formFieldState: object.isRequired,
    ruleId: string.isRequired,
    validateFormFields: func.isRequired,
    updateFormFieldState: func.isRequired,
    handleOnBlur: func.isRequired,
    getTextFieldProps: func.isRequired,
    error: object.isRequired,
    totalOrderItems: number.isRequired,
    clearErrors: func.isRequired,
    addressBookEntries: array.isRequired,
    loadAddressBook: func.isRequired,
    userType: string.isRequired,
    addressBookPageOn: number.isRequired,
    addressBookTotalPages: number.isRequired,
    totalAddresses: number.isRequired,
    flags: object.isRequired,
    actionsQasAddress: object.isRequired,
    hasQasFailed: bool.isRequired,
    subscriptionRecipientForm: func.isRequired,
    customerId: string.isRequired,
    brand: object.isRequired,
    searchVerifyAddress: func.isRequired,
    isWriteScopeCheckout: bool.isRequired,
    handleRecipientSubmit: func.isRequired,
    validZip: string.isRequired,
    updateSubscriptionReduxList: func.isRequired,
    subscription: object.isRequired,
    membershipType: string.isRequired,
    featureFlags: object.isRequired,
};

const validationRecipientForm = withValidation(SubscriptionRecipientForm, initState);

// Compose HOCs
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles),
)(validationRecipientForm);
